/*
 * Copyright (c) 2019 - 2020. Fastest Booking Ltd.
 *
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 *  the property of Fastest Booking Ltd and its suppliers,
 *  if any.  The intellectual and technical concepts contained
 *  herein are proprietary to Fastest Booking Ltd
 *  and its suppliers and may be covered by U.S. and Foreign Patents,
 *  patents in process, and are protected by trade secret or copyright law.
 *  Dissemination of this information or reproduction of this material
 *  is strictly forbidden unless prior written permission is obtained
 *  from Fastest Booking Ltd.
 */

export interface ConfigurationParameters {
  apiFileUrl: string;
}

export class Configuration {
  apiFileUrl: string;

  constructor(configurationParameters: ConfigurationParameters) {
    this.apiFileUrl = configurationParameters.apiFileUrl;
  }
}
